<script setup lang="ts">
const props = defineProps<{
  data: NewsletterPage,
}>()

// The upload is typed `string | Media` because Payload can return an
// unpopulated id — the GraphQL query always selects the full document.
const image = computed(() => (props.data.image && typeof props.data.image !== 'string' ? props.data.image : null))

const caption = computed(() => captionWithCredit(image.value?.caption, image.value?.credit))
</script>

<template>
  <div class="contents">
    <core-rich-text
      v-if="hasRichTextContent(data?.tagline)"
      :content="data.tagline"
      class="container-d px-1 mb-3"
      text-size-class="text-lg"
    />

    <pages-newsletter-form />

    <figure
      v-if="image"
      class="container-d px-1 my-3"
    >
      <core-image :image="image" />

      <core-rich-text
        v-if="caption"
        :content="caption"
        class="mt-0_35"
        text-size-class="text-xs"
      />
    </figure>
  </div>
</template>
